<div
  class="wrapper d-flex align-items-center p-2 default-border-radius"
  [class.active]="active()"
>
  <lbt-icon size="xlg" [color]="active() ? 'black-0' : 'black-4'">{{ icon() }}</lbt-icon>
  <lbt-text typography="body-2" color="black-0" class="m-l-4">{{ title() }}</lbt-text>
</div>
